<template>
  <div id="clientes">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="CATÁLOGO DE CLIENTES" color="primary darken-4" dark>
            <div slot="widget-content">
              <v-layout wrap class="container">
                <v-flex xs12 sm6>
                  <v-btn
                    color="success"
                    dark
                    fab
                    small
                    slot="activator"
                    @click="abrirDialogNuevoCliente"
                  >
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="sucursalSeleccionada"
                    :items="sucursalesUsuario"
                    item-text="nombreSucursal"
                    item-value="sucursalId"
                    label="Selecciona una sucursal"
                    solo
                    return-object
                  ></v-select>
                </v-flex>
                <form-cliente
                  :cliente="cliente"
                  :sucursal="sucursalSeleccionada"
                  ref="dialogCliente"
                  @onClienteAdded="onClienteAdded"
                  @onClienteUpdated="onClienteUpdated"
                ></form-cliente>
              </v-layout>

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-menu bottom left>
                        <v-btn slot="activator">
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-list>
                          <v-list-tile avatar @click="cancelarBusqueda()">
                            <v-list-tile-avatar>
                              <v-icon color="red">cancel</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-title
                              >Restaurar búsqueda</v-list-tile-title
                            >
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="headers"
                        :search="search"
                        :items="clientes"
                        :pagination.sync="pagination"
                        :rows-per-page-items="[
                          10,
                          25,
                          50,
                          { text: 'Todos', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="clienteId"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-avatar size="48">
                              <v-icon color="primary" medium
                                >account_circle</v-icon
                              >
                            </v-avatar>
                          </td>
                          <td>{{ props.item.nombreCompletoCliente }}</td>
                          <td>{{ props.item.nombreEntidad }}</td>
                          <td>{{ props.item.nombreMunicipio }}</td>
                          <td>{{ props.item.telefonoCelular }}</td>
                          <td>{{ props.item.correoContacto }}</td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="primary"
                              small
                              @click="getCliente(props.item.clienteId)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteCliente(props.item.clienteId)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                          >La búsqueda para "{{ search }}" no encontró
                          registros</v-alert
                        >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formCliente from "./FormCliente";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import clienteService from "@/services/clienteService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
    formCliente,
  },
  data() {
    return {
      search: "",
      pagination: {
        descending: true,
        sortBy: "clienteId",
      },
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "NOMBRE CLIENTE",
          align: "center",
          value: "nombreCompletoCliente",
        },
        { text: "ESTADO", align: "center", value: "nombreEntidad" },
        { text: "CIUDAD", align: "center", value: "nombreMunicipio" },
        { text: "CELULAR", align: "center", value: "Celular" },
        { text: "CORREO", align: "center", value: "Correo" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      sucursalesUsuario: [],
      sucursalSeleccionada: {
        sucursalId: 0,
        nombreSucursal: "",
      },
      clientes: [],
      cliente: {
        clienteId: 0,
        nombreCompletoCliente: "",
        domicilio: "",
        colonia: "",
        codigoPostal: "",
        paisId: 146,
        entidadId: null,
        municipioId: null,
        telefonoParticular: "",
        telefonoCelular: "",
        correoContacto: "",
        descuento: 0,
        municipio: {
          municipioId: 0,
          nombreMunicipio: "",
        },
        sucursalId: 0,
      },
    };
  },
  watch: {
    sucursalSeleccionada: function (n) {
      this.getClientes();
    },
  },
  mounted() {
    let self = this;
    try {
      let current_user = this.$store.state.currentUser;
      this.sucursalesUsuario = current_user.sucursales;
      if (this.sucursalesUsuario.length > 0) {
        this.sucursalSeleccionada = this.sucursalesUsuario[0];
        this.getClientes();
      }
    } catch (e) {
      self.codeFailed(
        "Ocurrió un error al extraer sucursales, es posible que se haya perdido la sesión o no tengas sucursales asignadas"
      );
    }
  },
  methods: {
    getClientes() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      clienteService
        .getAllBySucursal(self.sucursalSeleccionada.sucursalId)
        .then((result) => {
          self.clientes = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getCliente(clienteId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;

      clienteService
        .get(clienteId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR CLIENTE";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.$refs.dialogCliente.resetForm();
          console.log(result);
          self.cliente = result;
          self.$refs.dialogCliente.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteCliente(clienteId) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR CLIENTE",
          "¿Estás seguro de eliminar el cliente seleccionado, se eliminará toda la información relacionada a éste?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            clienteService
              .delete(clienteId)
              .then(() => {
                var i = this.clientes.findIndex(
                  (obj) => obj.clienteId == clienteId
                );
                self.clientes.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text = "Cliente eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                self.operationFailed(e);
                console.log(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onClienteAdded(cliente) {
      this.clientes.push(cliente);
    },
    onClienteUpdated(cliente) {
      var i = this.clientes.findIndex(
        (obj) => obj.clienteId == cliente.clienteId
      );
      this.clientes.splice(i, 1, cliente);
    },
    abrirDialogNuevoCliente() {
      if (this.sucursalSeleccionada.sucursalId === 0) {
        this.$store.state.snackbar.color = "error";
        this.$store.state.snackbar.text = "Selecciona una sucursal";
        this.$store.state.snackbar.visible = true;
      } else {
        this.$store.state.tituloForm = "AGREGAR CLIENTE";
        this.$store.state.iconoForm = "/images/general/agregar-40.png";
        this.$refs.dialogCliente.resetForm();
        this.$refs.dialogCliente.openDialog();
      }
    },
     cancelarBusqueda() {
        this.pagination.descending = true;
        this.pagination.sortBy = "clienteId";
    },
  },
};
</script>
